import React from 'react';
import { ReportFilters } from '../../types/Report';
import { formatDate } from '../../utils/date';

interface ReportHeaderProps {
  filters: ReportFilters;
  dataFreshness?: string;
  title?: string;
  comparePeriod?: { startDate: string; endDate: string };
}

const ReportHeader: React.FC<ReportHeaderProps> = ({
  filters,
  dataFreshness,
  title = 'Executive Dashboard',
  comparePeriod,
}) => {
  const formatDateRange = () => {
    if (filters.startDate && filters.endDate) {
      return `${formatDate(filters.startDate)} - ${formatDate(filters.endDate)}`;
    }
    return 'All dates';
  };

  const formatCompareMode = () => {
    switch (filters.compareMode) {
      case 'yoy':
        return 'Year-over-Year';
      case 'previous':
        return 'Previous Period';
      default:
        return 'None';
    }
  };

  const formatDataFreshness = () => {
    if (!dataFreshness) return 'Unknown';
    try {
      const date = new Date(dataFreshness);
      return formatDate(date.toISOString().split('T')[0]);
    } catch {
      return dataFreshness;
    }
  };

  return (
    <div
      style={{
        padding: '1rem',
        backgroundColor: 'white',
        borderBottom: '1px solid #dee2e6',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600' }}>{title}</h1>
          <div style={{ marginTop: '0.5rem', color: '#6c757d', fontSize: '0.9rem' }}>
            <span>Period: {formatDateRange()}</span>
            {filters.compareMode && (
              <>
                <span style={{ marginLeft: '1rem' }}>Compare: {formatCompareMode()}</span>
                {comparePeriod && (
                  <span style={{ marginLeft: '0.5rem' }}>
                    ({formatDate(comparePeriod.startDate)} - {formatDate(comparePeriod.endDate)})
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        <div style={{ textAlign: 'right', color: '#6c757d', fontSize: '0.9rem' }}>
          <div>Data as of: {formatDataFreshness()}</div>
        </div>
      </div>
    </div>
  );
};

export default ReportHeader;
